import React, { useState } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ASSISTANT_REPORT_DOWNLOAD_URL } from "../constants";
import { useNavigate } from "react-router-dom";

const ReportPage = () => {
  const navigate = useNavigate();
  const today = new Date();
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [loading, setLoading] = useState(false);  

  const handleDownload = async () => {
    if (!startDate || !endDate) {
      alert("Please select both start and end dates.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(ASSISTANT_REPORT_DOWNLOAD_URL, {
          startDate: startDate.toISOString().split("T")[0],
          endDate: endDate.toISOString().split("T")[0],
        }, 
        {
          responseType: "blob", // ✅ Important: Treat response as Blob
        }
      );      

      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "report.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);      
    } catch (error) {
      console.error("Error fetching CSV:", error);
      alert("Empty Data");
    }
    setLoading(false);
  };

  return (
    <div className="bg-white sm:p-6 lg:p-10 shadow-lg w-full flex flex-col items-center">
      <h2 className="text-lg font-semibold mb-4 text-center">Download Report</h2>

      <div className="flex items-center mb-4">
        <label className="w-32 text-sm font-medium text-gray-700">Start Date:</label>
        <DatePicker
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          className="w-full p-2 border rounded"
        />
      </div>

      <div className="flex items-center mb-4">
        <label className="w-32 text-sm font-medium text-gray-700">End Date:</label>
        <DatePicker
          selected={endDate}
          onChange={(date) => setEndDate(date)}
          className="w-full p-2 border rounded"
        />
      </div>

      <div className="flex justify-center mt-4">
        <button onClick={() => navigate(-1)} className="bg-gray-400 text-white px-4 py-2 rounded mr-2 w-40">
          Return
        </button>
        <button
          onClick={handleDownload}
          className="bg-blue-600 text-white px-4 py-2 rounded w-40"
          disabled={loading}
        >
          {loading ? <i className="fas fa-spinner fa-spin"></i> : "Download"}
        </button>
      </div>
    </div>
  );
};

export default ReportPage;